import { useEffect, useRef } from 'react';
import type { FC } from 'react';
import { useIntl } from 'react-intl';

import { useLocation } from '@xing-com/crate-core-router';
import { CreatePostButton } from '@xing-com/crate-entity-pages-common';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { useNewsContext } from '../../hooks/use-news-context/use-news-context';

import * as Styled from './create-post-trigger.styles';

type CreatePostTriggerProps = {
  param?: string;
  onCompleted?: () => void;
};
export const CreatePostTrigger: FC<CreatePostTriggerProps> = ({
  param = 'create',
  onCompleted = () => undefined,
}) => {
  const { $t } = useIntl();
  const { isSubpage } = usePageContext();
  const { isDetailPage } = useNewsContext();
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);

  const buttonRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const create = urlSearchParams.get(param);

    if (create === 'post' && !isDetailPage) {
      buttonRef.current?.click();
    }
  }, []);

  return (
    <Styled.CommboxInput data-testid="commboxTrigger">
      <CreatePostButton
        onCompleted={onCompleted}
        page={isSubpage ? 'entity_pages/subpage/news' : 'entity_pages/overview'}
      >
        {(onClick) => (
          <Styled.TextInput ref={buttonRef} onClick={onClick}>
            {$t({ id: 'COMMBOX_EMPTY_TEXT_FIELD' })}
          </Styled.TextInput>
        )}
      </CreatePostButton>
    </Styled.CommboxInput>
  );
};
